import { TableCell } from '@material-ui/core'
import styled from 'styled-components'

export const tabelaOPSStyles = {
  TableCellItem: styled(TableCell).attrs({ align: 'center' })``
}
